import { render, staticRenderFns } from "./AspacZoneOfficerRegistrationCreate.vue?vue&type=template&id=904284b8"
import script from "./AspacZoneOfficerRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./AspacZoneOfficerRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./AspacZoneOfficerRegistrationCreate.vue?vue&type=style&index=0&id=904284b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports